import Stack from '@mui/material/Stack';
import React from 'react';
import Select from '../form/Select';
import { VariablesIcon } from 'components/icons';

const VariablesToolbar = ({
  variables,
  loading,
  onSelect,
  fullWidth,
  ...rest
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        borderRadius: 1,
        pl: 2,
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'secondary.highlight',
        },
        '.react-select': {
          width: fullWidth ? '100%' : 85,
          ' > div': {
            border: 0,
            bgcolor: 'transparent',
            cursor: 'pointer',
            '& > div:nth-child(2)': {
              display: 'none',
            },
          },
          '& div[class*="placeholder"]': {
            color: 'secondary.contrastText',
            opacity: 1,
            fontWeight: 500,
          },
        },
      }}
    >
      <VariablesIcon sx={{ color: 'secondary.contrastText' }} />
      <Select
        transformValue
        fullWidth={fullWidth}
        menuPosition="fixed"
        placeholder="Variables"
        loading={loading}
        size="small"
        margin="none"
        onChange={onSelect}
        options={variables}
        {...rest}
      />
    </Stack>
  );
};

export default VariablesToolbar;
